import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import React from 'react';
import { bool } from 'prop-types';

import { actionCreators as authActions, currentUserPropTypes } from 'redux/authHandlers';
import { ROUTES } from 'constants/routes';
import { accountPropTypes } from 'redux/accountHandlers';
import { USER_SIGNOUT } from 'constants/analytics';

import Topbar from './layout';

class TopBarContainer extends React.PureComponent {
  onSignOut = () => this.props.dispatch(authActions.signOut(USER_SIGNOUT));

  onGoToSignIn = () => this.props.dispatch(push(ROUTES.SIGN_IN));

  handleClientSummary = () => {
    this.props.dispatch(push(ROUTES.CLIENT_SUMMARY));
  };

  handleClientDashboard = () => {
    this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));
  };

  handleUtilityLogoClick = () => {
    this.props.dispatch(push(this.props.isPublic ? ROUTES.PUBLIC_HOME : ROUTES.ACCOUNT_STATUS));
  };

  render() {
    return (
      <Topbar
        useClientSummary={this.props.useClientSummary}
        clientSummary={this.props.clientSummary}
        handleClientSummary={this.handleClientSummary}
        handleClientDashboard={this.handleClientDashboard}
        onSignOut={this.onSignOut}
        onGoToSignIn={this.onGoToSignIn}
        currentAccount={this.props.currentAccount}
        user={this.props.user}
        handleUtilityLogoClick={this.handleUtilityLogoClick}
        inMaintenance={this.props.inMaintenance}
        withoutLogo={this.props.withoutLogo}
      />
    );
  }
}

TopBarContainer.propTypes = {
  useClientSummary: bool,
  currentAccount: accountPropTypes,
  user: currentUserPropTypes,
  clientSummary: bool,
  isPublic: bool,
  inMaintenance: bool,
  withoutLogo: bool
};

const mapStateToProps = store => ({
  currentAccount: store.account.currentAccount,
  user: store.auth.currentUser
});

export default connect(mapStateToProps)(TopBarContainer);
